
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { UntypedFormGroup, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { ApiResponse } from "../../../../classes/api-response";
import { LogEvents } from 'src/app/model/logEvents';
import { TamperingAttemptLogsService } from "../../../../services/tampering-attempt-logs.service";
import { TamperingAttemptLogs } from "../../../../model/tampering-attempt-logs";
import { GeneralItemDetailDialogComponent } from "../../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { Constants } from "../../../../utils/constants";
import { AuthService } from "../../../../services/auth.service";
import { SnackService } from "../../../../services/snack.service";

@Component({
  selector: 'aw-box-logs',
  templateUrl: './box-logs.component.html',
  styleUrls: ['./box-logs.component.scss']
})
export class BoxLogsComponent {

  myControl = new UntypedFormControl();
  options: string[] = ['Info', 'Warning', 'Error'];
  filteredOptions!: Observable<string[]>;
  loadingGeneral = false;
  generalError?: ApiResponse;
  roles = Constants.roles;
  entities = Constants.entities;
  filteredEventsLogs: LogEvents[] = [];
  logsForm!: UntypedFormGroup;
  loggedUser: any;


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
  });

  headers = [
    'id',
    'timestamp',
    'duration',
    'source',
    'type',
    'message',
    'action'
  ];

  disabled = false;
  disabledItemId: number[] = [];
  dataSource!: MatTableDataSource<LogEvents>;
  panelOpenState = false;
  logsValidators: ValidatorFn[] = [];

  filter = {
    tipoLog: '',
    dataInizio: '',
    dataFine: ''
  }

  filterEpoch = {
    filterPattern: '',
    startTime: '',
    endTime: ''
  }

  Submit() {
    this.filterEpoch.filterPattern = this.filter.tipoLog;
    var dataInizio = new Date(this.filter.dataInizio);
    var epochDataInizio = dataInizio.getTime();
    this.filterEpoch.startTime = epochDataInizio.toString();
    var dataFine = new Date(this.filter.dataFine);
    var epochDataFine = dataFine.getTime();
    this.filterEpoch.endTime = epochDataFine.toString();
    console.log(this.filterEpoch);


  }


  constructor(
    public authService: AuthService,
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private snackService: SnackService,
    private tamperingAttemptLogsService: TamperingAttemptLogsService,

  ) {
    this.loggedUser = this.authService.loggedUser();
    this.logsForm = new UntypedFormGroup(
      {
        date: new UntypedFormControl(
          '',
          this.logsValidators
        ),
        idContratto: new UntypedFormControl(
          null,
          []
        ),
        idBox: new UntypedFormControl(
          null,
          []
        )
      }
    );
  }

  ngOnInit() {
    this.loggedUser = this.authService.loggedUser();

    if (this.loggedUser.role === this.roles.admin) {
      this.loadAllBoxLogs();
    }
    else if (this.loggedUser.role === this.roles.customer) {
      this.loadBoxLogsByCompany();
    }
  }

  loadAllBoxLogs(): void {
    this.tamperingAttemptLogsService.getAllTamperingAttemptLogs()
      .subscribe(res => {
        this.filteredEventsLogs = res;

        //console.log(this.filteredEventsLogs);
        this.dataSource = new MatTableDataSource(this.filteredEventsLogs);
        //console.log('this.dataSource', this.dataSource);
        this.dataSource.paginator = this.paginatorUsers;

        this.loadingGeneral = false;
      });
  }

  loadBoxLogsByCompany(): void {
    this.tamperingAttemptLogsService.getAllTamperingAttemptLogsByCompany(this.loggedUser.company.id)
      .subscribe(res => {
        this.filteredEventsLogs = res;

        //console.log(this.filteredEventsLogs);
        this.dataSource = new MatTableDataSource(this.filteredEventsLogs);
        //console.log('this.dataSource', this.dataSource);
        this.dataSource.paginator = this.paginatorUsers;

        this.loadingGeneral = false;
      });
  }

  public detectURLs(id: number) {
    // let url = message.split("- ", 2)
    // console.log('urlRegex', url);
    // if (url === null) {
    //   return;
    // }
    return this.tamperingAttemptLogsService.getUrlForDownloadS3Obj(id)
      .subscribe(
        res => {

          //console.log(res);
          if (res === null || res === '') {
            this.snackService.error('File not exists');
            return null;
          }
          //  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
          //  let url = message.match(urlRegex);

          return window.open(res as unknown as string, '_blank');

        },
        err => {
          console.log(err);
        },
      )
  }

  @ViewChild(MatSort)
  sort!: MatSort;


  // ngAfterViewInit() {
  //   this.dataSource.sort = this.sort;
  // }



  details(tamperingAttemptLogs: TamperingAttemptLogs): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: tamperingAttemptLogs });
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilters(event: string): void {

    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortItems(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {

      if (event.active === 'id') {
        if (event.direction === 'desc') {
          return b.id as number - (a.id ? a.id : 0);
        } else {
          return a.id as number - (b.id ? b.id : 0);
        }
      }

      if (event.active === 'timestamp') {
        if (event.direction === 'desc') {
          return ('' + b.timestamp).localeCompare('' + a.timestamp);
        } else {
          return ('' + a.timestamp).localeCompare('' + b.timestamp);
        }
      }

      if (event.active === 'source') {
        if (event.direction === 'desc') {
          return ('' + b.source).localeCompare('' + a.source);
        } else {
          return ('' + a.source).localeCompare('' + b.source);
        }
      }

      if (event.active === 'duration') {
        if (event.direction === 'desc') {
          return ('' + b.duration).localeCompare('' + a.duration);
        } else {
          return ('' + a.duration).localeCompare('' + b.duration);
        }
      }

      // if (event.active === 'type') {
      //   if (event.direction === 'desc') {
      //     return ('' + b.type).localeCompare('' + a.type);
      //   } else {
      //     return ('' + a.type).localeCompare('' + b.type);
      //   }
      // }

      if (event.active === 'message') {
        if (event.direction === 'asc') {
          return ('' + b.message).localeCompare('' + a.message);
        } else {
          return ('' + a.message).localeCompare('' + b.message);
        }
      }

      return -1;


    }
    );
  }

  @ViewChild('paginatorTamperingAttemptLogs') paginatorUsers!: MatPaginator;
}